import * as i0 from '@angular/core';
import { Injectable, Directive, Input, NgModule, inject, PLATFORM_ID, Inject, Component, ChangeDetectionStrategy, APP_INITIALIZER, Optional } from '@angular/core';
import * as i1 from '@spartacus/core';
import { Config, LoggerService, AuthActions, provideDefaultConfig, DeferLoadingStrategy, PageType, UrlModule, I18nModule, BaseSiteService, WindowRef, provideDefaultConfigFactory, provideConfigValidator } from '@spartacus/core';
import * as i3 from '@angular/common/http';
import { HttpParams, HttpHeaders, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { take, switchMap, EMPTY, Subscription, merge, BehaviorSubject, fromEvent, of, combineLatest, using, ReplaySubject, interval, last, Subject, shareReplay as shareReplay$1, timer, map as map$1, takeWhile as takeWhile$1, filter as filter$1, catchError, takeUntil } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import * as i6 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$1 from '@spartacus/storefront';
import { CategoryPageResultsEvent, PageEvent, SearchPageResultsEvent, ProductDetailsPageEvent, HomePageEvent, CarouselModule, MediaModule, SearchBoxComponentService, SearchBoxModule, provideOutlet, SearchBoxOutlets, OutletPosition, OutletContextData } from '@spartacus/storefront';
import { switchMap as switchMap$1, take as take$1, map, shareReplay, filter, distinctUntilChanged, tap, withLatestFrom, startWith, pairwise, distinctUntilKeyChanged, debounceTime, mergeMap, concatMap, takeWhile } from 'rxjs/operators';
import * as i3$1 from '@ngrx/store';
import * as i3$2 from '@spartacus/cart/base/root';
import { CartPageEvent, CartAddEntrySuccessEvent, CartRemoveEntrySuccessEvent, CartUpdateEntrySuccessEvent, MergeCartSuccessEvent } from '@spartacus/cart/base/root';
import { OrderPlacedEvent } from '@spartacus/order/root';
import * as i2$1 from '@spartacus/tracking/personalization/core';
import { cdsTranslations as cdsTranslations$1, cdsTranslationChunksConfig as cdsTranslationChunksConfig$1 } from '@spartacus/cds/assets';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function ProfileTagComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c0 = a0 => ({
  cxRoute: "product",
  params: a0
});
function MerchandisingCarouselComponent_ng_container_0_ng_template_4_cx_media_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 10);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().item;
    i0.ɵɵproperty("container", item_r2.images.PRIMARY);
  }
}
function MerchandisingCarouselComponent_ng_container_0_ng_template_4_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", item_r2.stock == null ? null : item_r2.stock.stockLevelStatus, " : ", item_r2.stock == null ? null : item_r2.stock.stockLevel, " ");
  }
}
function MerchandisingCarouselComponent_ng_container_0_ng_template_4_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2.stock == null ? null : item_r2.stock.stockLevelStatus, " ");
  }
}
function MerchandisingCarouselComponent_ng_container_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵelementStart(1, "a", 6);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵlistener("click", function MerchandisingCarouselComponent_ng_container_0_ng_template_4_Template_a_click_1_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).item;
      const merchandisingCarouselModel_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onMerchandisingCarouselItemClick(merchandisingCarouselModel_r3, item_r2));
    });
    i0.ɵɵtemplate(3, MerchandisingCarouselComponent_ng_container_0_ng_template_4_cx_media_3_Template, 1, 1, "cx-media", 7);
    i0.ɵɵelementStart(4, "h4");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, MerchandisingCarouselComponent_ng_container_0_ng_template_4_div_8_Template, 2, 2, "div", 9)(9, MerchandisingCarouselComponent_ng_container_0_ng_template_4_ng_template_9_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.item;
    const outOfStock_r5 = i0.ɵɵreference(10);
    i0.ɵɵproperty("cxAttributes", item_r2.metadata)("cxAttributesNamePrefix", "data-cx-merchandising-product");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 8, i0.ɵɵpureFunction1(10, _c0, item_r2)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r2.images == null ? null : item_r2.images.PRIMARY);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r2.price == null ? null : item_r2.price.formattedValue, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (item_r2.stock == null ? null : item_r2.stock.stockLevel) > 0)("ngIfElse", outOfStock_r5);
  }
}
function MerchandisingCarouselComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 3)(2, "cx-carousel", 4);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, MerchandisingCarouselComponent_ng_container_0_ng_template_4_Template, 11, 12, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const merchandisingCarouselModel_r3 = ctx.ngIf;
    const carouselItem_r6 = i0.ɵɵreference(5);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxAttributes", merchandisingCarouselModel_r3.metadata)("cxAttributesNamePrefix", "data-cx-merchandising-carousel");
    i0.ɵɵadvance();
    i0.ɵɵproperty("items", merchandisingCarouselModel_r3.items$)("title", i0.ɵɵpipeBind1(3, 5, ctx_r3.title$))("template", carouselItem_r6);
  }
}
const _c1 = a0 => ({
  query: a0
});
const _c2 = a0 => ({
  cxRoute: "search",
  params: a0
});
function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "cxHighlight");
    i0.ɵɵpipe(4, "cxUrl");
    i0.ɵɵlistener("mousedown", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_mousedown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowup", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowup_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.arrowdown", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowdown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.arrowleft", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowleft_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.arrowright", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowright_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.enter", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.escape", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_escape_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("blur", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_blur_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("click", function RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_click_1_listener() {
      const recentSearch_r3 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateChosenWord(recentSearch_r3));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_5_0;
    const recentSearch_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind3(3, 4, recentSearch_r3, (tmp_5_0 = i0.ɵɵpipeBind1(2, 2, ctx_r1.outletContext$)) == null ? null : tmp_5_0.search, false), i0.ɵɵsanitizeHtml)("routerLink", i0.ɵɵpipeBind1(4, 8, i0.ɵɵpureFunction1(12, _c2, i0.ɵɵpureFunction1(10, _c1, recentSearch_r3))));
  }
}
function RecentSearchesComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "h3");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 2);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵtemplate(7, RecentSearchesComponent_ng_container_0_ng_container_1_li_7_Template, 5, 14, "li", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const results_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "searchBox.recentSearches"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(6, 5, "cdsRecentSearches.ariaRecentSearches"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", results_r4);
  }
}
function RecentSearchesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RecentSearchesComponent_ng_container_0_ng_container_1_Template, 8, 7, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const results_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", results_r4 == null ? null : results_r4.length);
  }
}
function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 4);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵlistener("mousedown", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_mousedown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowup", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowup_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.arrowdown", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowdown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.arrowleft", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowleft_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.arrowright", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_arrowright_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.enter", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    })("keydown.escape", function TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template_a_keydown_escape_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.shareEvent($event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const phrase_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction1(6, _c2, i0.ɵɵpureFunction1(4, _c1, phrase_r3.searchPhrase))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", phrase_r3.searchPhrase, " ");
  }
}
function TrendingSearchesComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "h3");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 2);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵtemplate(7, TrendingSearchesComponent_ng_container_0_ng_container_1_li_7_Template, 4, 8, "li", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const searchPhrases_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "searchBox.trendingSearches"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(6, 5, "cdsTrendingSearches.ariaTrendingSearches"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", searchPhrases_r4);
  }
}
function TrendingSearchesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TrendingSearchesComponent_ng_container_0_ng_container_1_Template, 8, 7, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const searchPhrases_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", searchPhrases_r4 == null ? null : searchPhrases_r4.length);
  }
}
let CdsConfig = /*#__PURE__*/(() => {
  class CdsConfig {
    static {
      this.ɵfac = function CdsConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsConfig,
        factory: function CdsConfig_Factory(__ngFactoryType__) {
          let __ngConditionalFactory__ = null;
          if (__ngFactoryType__) {
            __ngConditionalFactory__ = new (__ngFactoryType__ || CdsConfig)();
          } else {
            __ngConditionalFactory__ = i0.ɵɵinject(Config);
          }
          return __ngConditionalFactory__;
        },
        providedIn: 'root'
      });
    }
  }
  return CdsConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function cdsConfigValidator(config) {
  if (!config.cds) {
    return 'Please configure the config.cds object before using the CDS library';
  }
  if (config.cds.profileTag !== undefined) {
    if (config.cds.profileTag.configUrl === undefined || config.cds.profileTag.configUrl.trim().length === 0) {
      return 'Please configure cds.profileTag.configUrl before using the CDS library';
    }
    if (config.cds.profileTag.javascriptUrl === undefined || config.cds.profileTag.javascriptUrl.trim().length === 0) {
      return 'Please configure cds.profileTag.configUrl before using the CDS library';
    }
  }
  if (config.cds.tenant === undefined || config.cds.tenant.trim().length === 0) {
    return 'Please configure cds.tenant before using CDS library';
  }
  if (config.cds.baseUrl === undefined) {
    return 'Please configure cds.baseUrl before using CDS library';
  }
  if (config.cds.endpoints === undefined || config.cds.endpoints.strategyProducts === undefined) {
    return 'Please configure the cds.endpoints before using CDS library';
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultCdsConfigFactory() {
  return {
    cds: {
      tenant: '',
      baseUrl: '',
      merchandising: {
        defaultCarouselViewportThreshold: 80
      },
      consentTemplateId: 'PROFILE',
      profileTag: {
        allowInsecureCookies: false
      }
    }
  };
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DynamicTemplate {
  static resolve(templateString, templateVariables) {
    for (const variableLabel of Object.keys(templateVariables)) {
      const placeholder = new RegExp('\\${' + variableLabel + '}', 'g');
      templateString = templateString.replace(placeholder, templateVariables[variableLabel]);
    }
    return templateString;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CdsEndpointsService = /*#__PURE__*/(() => {
  class CdsEndpointsService {
    constructor(cdsConfig) {
      this.cdsConfig = cdsConfig;
    }
    getUrl(endpoint, urlParams = {}, queryParams) {
      if (this.cdsConfig?.cds?.endpoints[endpoint]) {
        endpoint = this.cdsConfig.cds.endpoints[endpoint];
      }
      if (!urlParams['tenant']) {
        urlParams['tenant'] = this.cdsConfig.cds.tenant;
      }
      Object.keys(urlParams).forEach(key => {
        urlParams[key] = encodeURIComponent(urlParams[key]);
      });
      endpoint = DynamicTemplate.resolve(endpoint, urlParams);
      if (queryParams) {
        let httpParamsOptions;
        if (endpoint.includes('?')) {
          let queryParamsFromEndpoint;
          [endpoint, queryParamsFromEndpoint] = endpoint.split('?');
          httpParamsOptions = {
            fromString: queryParamsFromEndpoint
          };
        }
        let httpParams = new HttpParams(httpParamsOptions);
        Object.keys(queryParams).forEach(key => {
          const value = queryParams[key];
          if (value !== undefined) {
            if (value === null) {
              httpParams = httpParams.delete(key);
            } else {
              httpParams = httpParams.set(key, value);
            }
          }
        });
        const params = httpParams.toString();
        if (params.length) {
          endpoint += '?' + params;
        }
      }
      return this.getEndpoint(endpoint);
    }
    getEndpoint(endpoint) {
      /*
       * If the endpoint to get the url for already has the configured base url appended,
       * do not try and append it again
       */
      if (endpoint.startsWith(this.getBaseEndpoint())) {
        return endpoint;
      }
      if (!endpoint.startsWith('/')) {
        endpoint = '/' + endpoint;
      }
      return `${this.getBaseEndpoint()}${endpoint}`;
    }
    getBaseEndpoint() {
      if (!this.cdsConfig || !this.cdsConfig.cds || !this.cdsConfig.cds.baseUrl) {
        return '';
      }
      return this.cdsConfig.cds.baseUrl;
    }
    static {
      this.ɵfac = function CdsEndpointsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsEndpointsService)(i0.ɵɵinject(CdsConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsEndpointsService,
        factory: CdsEndpointsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CdsEndpointsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const STRATEGY_PRODUCTS_ENDPOINT_KEY = 'strategyProducts';
let CdsMerchandisingStrategyAdapter = /*#__PURE__*/(() => {
  class CdsMerchandisingStrategyAdapter {
    constructor(cdsEndpointsService, baseSiteService, http) {
      this.cdsEndpointsService = cdsEndpointsService;
      this.baseSiteService = baseSiteService;
      this.http = http;
    }
    loadProductsForStrategy(strategyId, strategyRequest = {}) {
      let headers = new HttpHeaders();
      if (strategyRequest.headers && strategyRequest.headers.consentReference) {
        headers = headers.set('consent-reference', strategyRequest.headers.consentReference);
      }
      return this.baseSiteService.getActive().pipe(take(1), switchMap(baseSite => this.http.get(this.cdsEndpointsService.getUrl(STRATEGY_PRODUCTS_ENDPOINT_KEY, {
        baseSite,
        strategyId
      }, strategyRequest.queryParams), {
        headers
      })));
    }
    static {
      this.ɵfac = function CdsMerchandisingStrategyAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsMerchandisingStrategyAdapter)(i0.ɵɵinject(CdsEndpointsService), i0.ɵɵinject(i1.BaseSiteService), i0.ɵɵinject(i3.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsMerchandisingStrategyAdapter,
        factory: CdsMerchandisingStrategyAdapter.ɵfac
      });
    }
  }
  return CdsMerchandisingStrategyAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AttributesDirective = /*#__PURE__*/(() => {
  class AttributesDirective {
    set cxAttributesNamePrefix(attributesNamePrefix) {
      this._attributesNamePrefix = attributesNamePrefix;
    }
    constructor(renderer, elementRef) {
      this.renderer = renderer;
      this.elementRef = elementRef;
    }
    ngOnChanges() {
      if (this.cxAttributes) {
        for (const attributeName in this.cxAttributes) {
          if (this.cxAttributes.hasOwnProperty(attributeName)) {
            const attributeValue = this.cxAttributes[attributeName];
            if (attributeValue) {
              const _attributeName = this._attributesNamePrefix ? `${this._attributesNamePrefix}-${attributeName}` : attributeName;
              this.renderer.setAttribute(this.elementRef.nativeElement, _attributeName, attributeValue);
            }
          }
        }
      }
    }
    static {
      this.ɵfac = function AttributesDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AttributesDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AttributesDirective,
        selectors: [["", "cxAttributes", ""]],
        inputs: {
          cxAttributes: "cxAttributes",
          cxAttributesNamePrefix: "cxAttributesNamePrefix"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return AttributesDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AttributesModule = /*#__PURE__*/(() => {
  class AttributesModule {
    static {
      this.ɵfac = function AttributesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AttributesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AttributesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return AttributesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MerchandisingCarouselViewedEvent {
  constructor(carouselEvent, productSkus) {
    this.name = 'CarouselViewed';
    this.data = {
      ...carouselEvent,
      productSkus
    };
  }
}
class MerchandisingCarouselClickedEvent {
  constructor(carouselEvent, slotId, sku, imageUrl) {
    this.name = 'CarouselClicked';
    this.data = {
      ...carouselEvent,
      slotId,
      sku,
      imageUrl
    };
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MerchandisingStrategyAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MerchandisingStrategyConnector = /*#__PURE__*/(() => {
  class MerchandisingStrategyConnector {
    constructor(strategyAdapter) {
      this.strategyAdapter = strategyAdapter;
    }
    loadProductsForStrategy(strategyId, strategyRequest) {
      return this.strategyAdapter.loadProductsForStrategy(strategyId, strategyRequest);
    }
    static {
      this.ɵfac = function MerchandisingStrategyConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MerchandisingStrategyConnector)(i0.ɵɵinject(MerchandisingStrategyAdapter));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MerchandisingStrategyConnector,
        factory: MerchandisingStrategyConnector.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MerchandisingStrategyConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CdsBackendNotificationAdapter {}
let OccBackendNotification = /*#__PURE__*/(() => {
  class OccBackendNotification {
    constructor(http, occEndpoints) {
      this.http = http;
      this.occEndpoints = occEndpoints;
    }
    notifySuccessfulLogin() {
      return this.http.post(`${this.occEndpoints.getBaseUrl()}/users/current/loginnotification`, {}).pipe(switchMap$1(() => EMPTY));
    }
    static {
      this.ɵfac = function OccBackendNotification_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccBackendNotification)(i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i1.OccEndpointsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccBackendNotification,
        factory: OccBackendNotification.ɵfac
      });
    }
  }
  return OccBackendNotification;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var InternalProfileTagEventNames = /*#__PURE__*/function (InternalProfileTagEventNames) {
  InternalProfileTagEventNames["CONSENT_REFERENCE_LOADED"] = "profiletag_consentReferenceLoaded";
  InternalProfileTagEventNames["DEBUG_FLAG_CHANGED"] = "profiletag_debugFlagChanged";
  return InternalProfileTagEventNames;
}(InternalProfileTagEventNames || {});
class NavigatedPushEvent {
  constructor(data) {
    this.name = 'Navigated';
    this.data = data;
  }
}
class ConsentChangedPushEvent {
  constructor(granted) {
    this.name = 'ConsentChanged';
    this.data = {
      granted: undefined
    };
    this.data.granted = granted;
  }
}
class KeywordSearchPushEvent {
  constructor(data) {
    this.name = 'KeywordSearch';
    this.data = data;
  }
}
class ProductViewPushEvent {
  constructor(data) {
    this.name = 'ProductDetailsPageViewed';
    this.data = data;
  }
}
class CategoryViewPushEvent {
  constructor(data) {
    this.name = 'CategoryPageViewed';
    this.data = data;
  }
}
// TODO:#cds - check the class name and the `name` property
class BrandPageVisitedEvent {
  constructor(data) {
    this.name = 'BrandPageVisitedEvent';
    this.data = data;
  }
}
class HomePageViewPushEvent {
  constructor(data) {
    this.name = 'HomePageViewed';
    this.data = data;
  }
}
class OrderConfirmationPushEvent {
  constructor(data) {
    this.name = 'OrderConfirmationPageViewed';
    this.data = data;
  }
}
class CartViewPushEvent {
  constructor(data) {
    this.name = 'CartPageViewed';
    this.data = data;
  }
}
class AddedToCartPushEvent {
  constructor(data) {
    this.name = 'AddedToCart';
    this.data = data;
  }
}
class RemovedFromCartPushEvent {
  constructor(data) {
    this.name = 'RemovedFromCart';
    this.data = data;
  }
}
class ModifiedCartPushEvent {
  constructor(data) {
    this.name = 'ModifiedCart';
    this.data = data;
  }
}
class CartSnapshotPushEvent {
  constructor(data) {
    this.name = 'CartSnapshot';
    this.data = data;
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProfileTagEventService = /*#__PURE__*/(() => {
  class ProfileTagEventService {
    constructor(winRef, config, baseSiteService, platform) {
      this.winRef = winRef;
      this.config = config;
      this.baseSiteService = baseSiteService;
      this.platform = platform;
      this.subscription = new Subscription();
      this.profileTagDebug = false;
      this.profileTagEvents$ = merge(this.setConsentReference(), this.debugModeChanged());
      this.logger = inject(LoggerService);
      this.initWindow();
      this.setConsentReferenceFromLocalStorage();
    }
    setConsentReferenceFromLocalStorage() {
      if (this.winRef.isBrowser() && this.winRef.localStorage) {
        const profileTagMetadata = JSON.parse(this.winRef.localStorage.getItem('profiletag') || '{"cr":{}}');
        this.subscription.add(this.baseSiteService.getActive().pipe(take$1(1)).subscribe(baseSite => {
          this.latestConsentReference = new BehaviorSubject(profileTagMetadata.cr[`${baseSite}-consentReference`]?.consentReference);
        }));
      }
    }
    getProfileTagEvents() {
      return this.profileTagEvents$;
    }
    getConsentReference() {
      if (!this.consentReference$ && this.winRef.nativeWindow) {
        this.consentReference$ = fromEvent(this.winRef.nativeWindow, InternalProfileTagEventNames.CONSENT_REFERENCE_LOADED).pipe(map(event => event), map(event => event.detail.consentReference), shareReplay(1));
      }
      return this.consentReference$;
    }
    handleConsentWithdrawn() {
      this.consentReference$ = null;
      this.latestConsentReference.next(null);
    }
    addTracker() {
      return this.baseSiteService.getActive().pipe(filter(() => isPlatformBrowser(this.platform)), filter(siteId => Boolean(siteId)), distinctUntilChanged(), tap(() => this.addScript()), tap(siteId => this.createConfig(siteId)));
    }
    notifyProfileTagOfEventOccurrence(event) {
      try {
        this.profileTagWindow?.Y_TRACKING?.eventLayer?.push(event);
      } catch (e) {
        this.logger.log(`Unexpected error when calling profiletag push method ${e}`);
      }
    }
    setConsentReference() {
      return this.winRef.nativeWindow && !!this.getConsentReference() ? this.getConsentReference().pipe(tap(consentReference => {
        this.latestConsentReference.next(consentReference);
      })) : of(null);
    }
    debugModeChanged() {
      return this.winRef.nativeWindow ? fromEvent(this.winRef.nativeWindow, InternalProfileTagEventNames.DEBUG_FLAG_CHANGED).pipe(map(event => event), tap(event => this.profileTagDebug = event.detail.debug)) : of();
    }
    createConfig(siteId) {
      const cds = this.config.cds;
      if (cds) {
        const newConfig = {
          ...cds.profileTag,
          tenant: cds.tenant,
          siteId,
          spa: true
        };
        this.exposeConfig(newConfig);
      }
    }
    /*
     * Checks if the script with the given source exists in the document or not.
     */
    isScriptLoaded(scriptSource) {
      return !!this.winRef.document.querySelector(`script[src="${scriptSource}"]`);
    }
    addScript() {
      const javascriptUrl = this.config.cds?.profileTag?.javascriptUrl;
      if (javascriptUrl) {
        if (this.isScriptLoaded(javascriptUrl)) {
          return;
        }
        const profileTagScript = this.winRef.document.createElement('script');
        profileTagScript.type = 'text/javascript';
        profileTagScript.async = true;
        profileTagScript.src = javascriptUrl;
        this.winRef.document.getElementsByTagName('head')[0].appendChild(profileTagScript);
      }
    }
    initWindow() {
      if (!isPlatformBrowser(this.platform)) {
        return;
      }
      this.profileTagWindow = this.winRef.nativeWindow;
      this.profileTagWindow.Y_TRACKING = this.profileTagWindow.Y_TRACKING || {};
      this.profileTagWindow.Y_TRACKING.eventLayer = this.profileTagWindow.Y_TRACKING.eventLayer || [];
    }
    exposeConfig(options) {
      const q = this.profileTagWindow.Y_TRACKING.q || [];
      if (q.length !== 0) {
        return;
      }
      q.push([options]);
      this.profileTagWindow.Y_TRACKING.q = q;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function ProfileTagEventService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagEventService)(i0.ɵɵinject(i1.WindowRef), i0.ɵɵinject(CdsConfig), i0.ɵɵinject(i1.BaseSiteService), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProfileTagEventService,
        factory: ProfileTagEventService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProfileTagEventService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CdsBackendConnector = /*#__PURE__*/(() => {
  class CdsBackendConnector {
    constructor(cdsBackendNotificationAdapter) {
      this.cdsBackendNotificationAdapter = cdsBackendNotificationAdapter;
    }
    notifySuccessfulLogin() {
      return this.cdsBackendNotificationAdapter.notifySuccessfulLogin();
    }
    static {
      this.ɵfac = function CdsBackendConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsBackendConnector)(i0.ɵɵinject(CdsBackendNotificationAdapter));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsBackendConnector,
        factory: CdsBackendConnector.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CdsBackendConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProfileTagLifecycleService = /*#__PURE__*/(() => {
  class ProfileTagLifecycleService {
    constructor(consentService, config, actionsSubject) {
      this.consentService = consentService;
      this.config = config;
      this.actionsSubject = actionsSubject;
    }
    consentChanged() {
      return this.consentService.getConsent(this.config.cds?.consentTemplateId ?? '').pipe(map(profileConsent => {
        if (profileConsent) {
          return this.consentService.isConsentGiven(profileConsent);
        } else {
          return false;
        }
      }), map(granted => {
        return new ConsentChangedPushEvent(granted);
      }));
    }
    loginSuccessful() {
      return this.actionsSubject.pipe(filter(action => action.type === AuthActions.LOGIN), map(() => true));
    }
    static {
      this.ɵfac = function ProfileTagLifecycleService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagLifecycleService)(i0.ɵɵinject(i1.ConsentService), i0.ɵɵinject(CdsConfig), i0.ɵɵinject(i3$1.ActionsSubject));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProfileTagLifecycleService,
        factory: ProfileTagLifecycleService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProfileTagLifecycleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProfileTagInjectorService = /*#__PURE__*/(() => {
  class ProfileTagInjectorService {
    constructor(profileTagEventTracker, cdsBackendConnector, profileTagLifecycleService) {
      this.profileTagEventTracker = profileTagEventTracker;
      this.cdsBackendConnector = cdsBackendConnector;
      this.profileTagLifecycleService = profileTagLifecycleService;
    }
    track() {
      return this.profileTagEventTracker.addTracker().pipe(switchMap$1(_ => merge(this.profileTagEventTracker.getProfileTagEvents(), this.notifyEcOfLoginSuccessful()).pipe(map(() => true))));
    }
    notifyEcOfLoginSuccessful() {
      return this.profileTagLifecycleService.loginSuccessful().pipe(switchMap$1(_ => {
        return this.cdsBackendConnector.notifySuccessfulLogin().pipe(map(() => true));
      }));
    }
    static {
      this.ɵfac = function ProfileTagInjectorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagInjectorService)(i0.ɵɵinject(ProfileTagEventService), i0.ɵɵinject(CdsBackendConnector), i0.ɵɵinject(ProfileTagLifecycleService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProfileTagInjectorService,
        factory: ProfileTagInjectorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProfileTagInjectorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProfileTagComponent = /*#__PURE__*/(() => {
  class ProfileTagComponent {
    constructor(profileTagInjector) {
      this.profileTagInjector = profileTagInjector;
      this.profileTagEnabled$ = this.profileTagInjector.track();
    }
    static {
      this.ɵfac = function ProfileTagComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagComponent)(i0.ɵɵdirectiveInject(ProfileTagInjectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProfileTagComponent,
        selectors: [["cx-profiletag"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"]],
        template: function ProfileTagComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ProfileTagComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.profileTagEnabled$));
          }
        },
        dependencies: [i2.NgIf, i2.AsyncPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ProfileTagComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProfileTagCmsModule = /*#__PURE__*/(() => {
  class ProfileTagCmsModule {
    static {
      this.ɵfac = function ProfileTagCmsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagCmsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ProfileTagCmsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ProfileTagComponent: {
              component: ProfileTagComponent,
              deferLoading: DeferLoadingStrategy.INSTANT
            }
          }
        })],
        imports: [CommonModule]
      });
    }
  }
  return ProfileTagCmsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConsentReferenceInterceptor = /*#__PURE__*/(() => {
  class ConsentReferenceInterceptor {
    constructor(profileTagEventTracker, occEndpoints) {
      this.profileTagEventTracker = profileTagEventTracker;
      this.occEndpoints = occEndpoints;
    }
    intercept(request, next) {
      if (!this.profileTagEventTracker.latestConsentReference || !this.profileTagEventTracker.latestConsentReference.value || !this.isOccUrl(request.url)) {
        return next.handle(request);
      }
      const cdsHeaders = request.headers.set('X-Consent-Reference', this.profileTagEventTracker.latestConsentReference.value);
      const cdsRequest = request.clone({
        headers: cdsHeaders
      });
      return next.handle(cdsRequest);
    }
    isOccUrl(url) {
      return url.includes(this.occEndpoints.getBaseUrl());
    }
    static {
      this.ɵfac = function ConsentReferenceInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConsentReferenceInterceptor)(i0.ɵɵinject(ProfileTagEventService), i0.ɵɵinject(i1.OccEndpointsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConsentReferenceInterceptor,
        factory: ConsentReferenceInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConsentReferenceInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DebugInterceptor = /*#__PURE__*/(() => {
  class DebugInterceptor {
    constructor(profileTagEventTracker, occEndpoints) {
      this.profileTagEventTracker = profileTagEventTracker;
      this.occEndpoints = occEndpoints;
    }
    intercept(request, next) {
      if (!this.isOccUrl(request.url)) {
        return next.handle(request);
      }
      const cdsHeaders = request.headers.set('X-Profile-Tag-Debug', this.profileTagEventTracker.profileTagDebug.toString());
      const cdsRequest = request.clone({
        headers: cdsHeaders
      });
      return next.handle(cdsRequest);
    }
    isOccUrl(url) {
      return url.includes(this.occEndpoints.getBaseUrl());
    }
    static {
      this.ɵfac = function DebugInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DebugInterceptor)(i0.ɵɵinject(ProfileTagEventService), i0.ɵɵinject(i1.OccEndpointsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DebugInterceptor,
        factory: DebugInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DebugInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProfileTagModule = /*#__PURE__*/(() => {
  class ProfileTagModule {
    static {
      this.ɵfac = function ProfileTagModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ProfileTagModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: HTTP_INTERCEPTORS,
          useExisting: ConsentReferenceInterceptor,
          multi: true
        }, {
          provide: HTTP_INTERCEPTORS,
          useExisting: DebugInterceptor,
          multi: true
        }, {
          provide: CdsBackendNotificationAdapter,
          useClass: OccBackendNotification
        }],
        imports: [ProfileTagCmsModule]
      });
    }
  }
  return ProfileTagModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A service to convert spartacus events into profiletag push events that can be picked up and processed by profiletag.
 * The service observes the event service and the active cart service for supported events. These events are parsed into
 * a profiletag compliant format and enriched by segments and actions from the latest personalization context.
 *
 * Currently supported events from the event service:
 *  - CartPageVisited
 *  - CategoryPageVisited
 *  - HomePageVisited
 *  - KeywordSearchPageVisited
 *  - OrderConfirmationPageVisited
 *  - PageVisited
 *  - ProductDetailsPageVisited
 *  - CartAddEntrySuccessEvent
 *  - CartRemoveEntrySuccessEvent
 *  - CartUpdateEntrySuccessEvent
 */
let ProfileTagPushEventsService = /*#__PURE__*/(() => {
  class ProfileTagPushEventsService {
    constructor(eventService, personalizationContextService, activeCartFacade) {
      this.eventService = eventService;
      this.personalizationContextService = personalizationContextService;
      this.activeCartFacade = activeCartFacade;
      this.pushEvents$ = merge(this.categoryPageVisited(), this.productDetailsPageView(), this.searchResultsChanged(), this.homePageVisitedEvent(), this.cartPageVisitedEvent(), this.navigatedEvent(), this.orderConfirmationPageVisited(), this.addedToCart(), this.removedFromCart(), this.modifiedCart(), this.cartChangedEvent());
    }
    /**
     * Returns a push event emitting observable that emits all converted events emitted by the event or the active cart service.
     * These events are enriched with segments and actions from the latest personalization context.
     *
     * @returns an observable emitting profiletag push events
     */
    getPushEvents() {
      return this.pushEvents$.pipe(withLatestFrom(merge(of({
        segments: undefined,
        actions: undefined
      }), this.personalizationContextService.getPersonalizationContext())), map(([item, personalizationContext]) => {
        item.data = item.data ? item.data : {};
        item.data.segments = personalizationContext?.segments;
        item.data.actions = personalizationContext?.actions;
        return item;
      }));
    }
    /**
     * Adds a new push event emitting observable to this service. This observable will be merged with the internal one.
     * This method can be used to extend the functionality of this service at runtime.
     *
     * @param event an observable emitting profiltag push events
     */
    addPushEvent(event) {
      this.pushEvents$ = merge(this.pushEvents$, event);
    }
    /**
     * Emits the category page visited event.
     *
     * @returns an observable emitting events that describe category page visits in a profiltag compliant way
     * @see CategoryPageResultsEvent
     * @see CategoryViewPushEvent
     */
    categoryPageVisited() {
      return this.eventService.get(CategoryPageResultsEvent).pipe(withLatestFrom(this.eventService.get(PageEvent).pipe(startWith(null),
      // https://github.com/ReactiveX/rxjs/issues/4772
      pairwise())), distinctUntilChanged(([previouslyEmittedCategoryPage], [currentCategoryPage, [previousRoute, currentRoute]]) => {
        return previouslyEmittedCategoryPage.categoryCode === currentCategoryPage.categoryCode && previousRoute.navigation.semanticRoute === currentRoute.navigation.semanticRoute;
        // A true means that this item is not unique, so this is hard to wrap your head around.
        // What we are saying, is that if the category code is the same AND the last emitted semantic route is the
        // same then this is a duplicate (i.e. via a facet change). In other words, no other page type was visited,
        // and we are on the same category code.
      }), map(([categoryPageEvent]) => new CategoryViewPushEvent({
        productCategory: categoryPageEvent.categoryCode,
        productCategoryName: categoryPageEvent.categoryName
      })));
    }
    /**
     * Listens to SearchPageResultsEvent events
     *
     * @returns an observable emitting events that describe keyword search page visits in a profiltag compliant way
     * @see SearchPageResultsEvent
     * @see KeywordSearchPushEvent
     */
    searchResultsChanged() {
      return this.eventService.get(SearchPageResultsEvent).pipe(distinctUntilKeyChanged('searchTerm'), map(searchEvent => new KeywordSearchPushEvent({
        searchTerm: searchEvent.searchTerm,
        numResults: searchEvent.numberOfResults
      })));
    }
    /**
     * Listens to ProductDetailsPageEvent events
     *
     * @returns an observable emitting events that describe product detail page visits in a profiltag compliant way
     * @see ProductDetailsPageEvent
     * @see ProductViewPushEvent
     */
    productDetailsPageView() {
      return this.eventService.get(ProductDetailsPageEvent).pipe(map(item => new ProductViewPushEvent({
        productSku: item.code,
        productName: item.name,
        productPrice: item.price ? item.price.value : undefined,
        productCategoryName: item.categories ? item.categories[item.categories.length - 1].name : undefined,
        productCategory: item.categories ? item.categories[item.categories.length - 1].code : undefined,
        categories: this.categoriesToIds(item.categories)
      })));
    }
    /**
     * Listens to PageVisited events
     *
     * @returns an observable emitting events that describe page visits in a profiltag compliant way
     * @see PageVisited
     * @see NavigatedPushEvent
     */
    navigatedEvent() {
      return this.eventService.get(PageEvent).pipe(map(() => new NavigatedPushEvent()));
    }
    /**
     * Listens to CartPageVisited events
     *
     * @returns an observable emitting events that describe cart page visits in a profiltag compliant way
     * @see CartPageVisited
     * @see CartViewPushEvent
     */
    cartPageVisitedEvent() {
      return this.eventService.get(CartPageEvent).pipe(map(() => new CartViewPushEvent()));
    }
    /**
     * Listens to HomePageEvent events
     *
     * @returns an observable emitting events that describe home page visits in a profiltag compliant way
     * @see HomePageEvent
     * @see HomePageViewPushEvent
     */
    homePageVisitedEvent() {
      return this.eventService.get(HomePageEvent).pipe(map(() => new HomePageViewPushEvent()));
    }
    /**
     * Listens to OrderPlacedEvent events
     *
     * @returns an observable emitting events that describe order confirmation page visits in a profiltag compliant way
     * @see OrderPlacedEvent
     * @see OrderConfirmationPushEvent
     */
    orderConfirmationPageVisited() {
      return this.eventService.get(OrderPlacedEvent).pipe(map(() => new OrderConfirmationPushEvent()));
    }
    /**
     * Listens to @CartAddEntrySuccessEvent events, transforms them to @AddedToCartPushEvent .
     *
     * @returns an observable emitting @AddedToCartPushEvent events
     * @see CartAddEntrySuccessEvent
     * @see AddedToCartPushEvent
     */
    addedToCart() {
      return this.eventService.get(CartAddEntrySuccessEvent).pipe(map(item => new AddedToCartPushEvent({
        productQty: item.quantityAdded,
        productSku: item.entry.product.code,
        productName: item.entry.product.name,
        cartId: item.cartId,
        cartCode: item.cartCode,
        productPrice: this.getProductPrice(item),
        categories: this.categoriesToIds(item.entry.product.categories),
        productCategoryName: item.entry.product.categories ? item.entry.product.categories[item.entry.product.categories.length - 1].name : undefined,
        productCategory: item.entry.product.categories ? item.entry.product.categories[item.entry.product.categories.length - 1].code : undefined
      })));
    }
    /**
     * Listens to @CartRemoveEntrySuccessEvent events, transforms them to @RemovedFromCartPushEvent
     *
     * @returns an observable emitting @RemovedFromCartPushEvent events
     * @see CartRemoveEntrySuccessEvent
     * @see RemovedFromCartPushEvent
     */
    removedFromCart() {
      return this.eventService.get(CartRemoveEntrySuccessEvent).pipe(map(item => new RemovedFromCartPushEvent({
        productSku: item.entry.product.code,
        productName: item.entry.product.name,
        cartId: item.cartId,
        cartCode: item.cartCode,
        productCategoryName: item.entry.product.categories ? item.entry.product.categories[item.entry.product.categories.length - 1].name : undefined,
        productCategory: item.entry.product.categories ? item.entry.product.categories[item.entry.product.categories.length - 1].code : undefined,
        categories: this.categoriesToIds(item.entry.product.categories)
      })));
    }
    /**
     * Listens to @CartUpdateEntrySuccessEvent events, transforms them to @ModifiedCartPushEvent
     *
     * @returns an observable emitting @ModifiedCartPushEvent events
     * @see CartUpdateEntrySuccessEvent
     * @see ModifiedCartPushEvent
     */
    modifiedCart() {
      return this.eventService.get(CartUpdateEntrySuccessEvent).pipe(map(item => new ModifiedCartPushEvent({
        productQty: item.quantity,
        productSku: item.entry.product.code,
        productName: item.entry.product.name,
        cartId: item.cartId,
        cartCode: item.cartCode,
        categories: this.categoriesToIds(item.entry.product.categories),
        productCategoryName: item.entry.product.categories ? item.entry.product.categories[item.entry.product.categories.length - 1].name : undefined,
        productCategory: item.entry.product.categories ? item.entry.product.categories[item.entry.product.categories.length - 1].code : undefined
      })));
    }
    /**
     * Listens to @CartAddEntrySuccessEvent , @CartUpdateEntrySuccessEvent and @CartRemoveEntrySuccessEvent events,
     * transforms them to @CartSnapshotPushEvent whenever there is an activity on the cart.
     *
     * @returns an observable emitting @CartSnapshotPushEvent events
     * @see CartAddEntrySuccessEvent
     * @see CartUpdateEntrySuccessEvent
     * @see CartRemoveEntrySuccessEvent
     * @see MergeCartSuccessEvent
     * @see CartSnapshotPushEvent
     */
    cartChangedEvent() {
      return merge(this.eventService.get(CartAddEntrySuccessEvent), this.eventService.get(CartUpdateEntrySuccessEvent), this.eventService.get(CartRemoveEntrySuccessEvent), this.eventService.get(MergeCartSuccessEvent)).pipe(switchMap$1(() => this.activeCartFacade.takeActive()), map(cart => new CartSnapshotPushEvent({
        cart
      })));
    }
    getProductPrice(event) {
      if (!event.entry.totalPrice || !event.entry.totalPrice.value || !event.entry.quantity) {
        return undefined;
      }
      return parseFloat((event.entry.totalPrice.value / event.entry.quantity).toFixed(2));
    }
    categoriesToIds(categories) {
      return categories.map(category => category.code);
    }
    static {
      this.ɵfac = function ProfileTagPushEventsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProfileTagPushEventsService)(i0.ɵɵinject(i1.EventService), i0.ɵɵinject(i2$1.PersonalizationContextService), i0.ɵɵinject(i3$2.ActiveCartFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProfileTagPushEventsService,
        factory: ProfileTagPushEventsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProfileTagPushEventsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let TrackingService = /*#__PURE__*/(() => {
  class TrackingService {
    constructor(profileTagLifecycleService, profileTagPushEventsService, profileTagEventTracker) {
      this.profileTagLifecycleService = profileTagLifecycleService;
      this.profileTagPushEventsService = profileTagPushEventsService;
      this.profileTagEventTracker = profileTagEventTracker;
    }
    static factory(trackingService) {
      const factoryFunction = () => {
        trackingService.trackEvents();
      };
      return factoryFunction;
    }
    trackEvents() {
      this.profileTagPushEventsService.getPushEvents().pipe(withLatestFrom(this.profileTagLifecycleService.consentChanged().pipe(tap(event => {
        // always notify of consent changes
        this.profileTagEventTracker.notifyProfileTagOfEventOccurrence(event);
      }))), filter(([_event, consentChanged]) => consentChanged.data.granted),
      //don't notify other events until consent is granted
      tap(([event]) => {
        this.profileTagEventTracker.notifyProfileTagOfEventOccurrence(event);
      })).subscribe();
    }
    static {
      this.ɵfac = function TrackingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingService)(i0.ɵɵinject(ProfileTagLifecycleService), i0.ɵɵinject(ProfileTagPushEventsService), i0.ɵɵinject(ProfileTagEventService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TrackingService,
        factory: TrackingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TrackingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let TrackingModule = /*#__PURE__*/(() => {
  class TrackingModule {
    static {
      this.ɵfac = function TrackingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TrackingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          multi: true,
          provide: APP_INITIALIZER,
          useFactory: TrackingService.factory,
          deps: [TrackingService]
        }]
      });
    }
  }
  return TrackingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CdsMerchandisingUserContextService = /*#__PURE__*/(() => {
  class CdsMerchandisingUserContextService {
    constructor(routingService, productSearchService, profileTagEventService, profileTagLifecycleService, facetService) {
      this.routingService = routingService;
      this.productSearchService = productSearchService;
      this.profileTagEventService = profileTagEventService;
      this.profileTagLifecycleService = profileTagLifecycleService;
      this.facetService = facetService;
    }
    getUserContext() {
      return combineLatest([this.getConsentReferenceContext(), this.getPageContext(), this.getSearchContext()]).pipe(map(([consentContext, pageContext, searchContext]) => {
        const result = {
          ...consentContext,
          ...pageContext
        };
        if (!pageContext.products) {
          result['facets'] = searchContext.facets;
          result['searchPhrase'] = searchContext.searchPhrase;
        }
        return result;
      }), distinctUntilChanged((prev, curr) => prev.facets === curr.facets && prev.searchPhrase === curr.searchPhrase && prev.consentReference === curr.consentReference && prev.category === curr.category && prev.products === curr.products));
    }
    getConsentReferenceContext() {
      return this.profileTagLifecycleService.consentChanged().pipe(switchMap$1(changed => {
        if (changed.data.granted) {
          return this.profileTagEventService.getConsentReference().pipe(map(consentReference => ({
            consentReference
          })));
        } else {
          this.profileTagEventService.handleConsentWithdrawn();
          return of({
            consentReference: ''
          });
        }
      }));
    }
    getPageContext() {
      return this.routingService.getPageContext().pipe(map(pageContext => {
        const result = {};
        if (pageContext.type === PageType.PRODUCT_PAGE) {
          result.products = [pageContext.id];
        } else if (pageContext.type === PageType.CATEGORY_PAGE) {
          result.category = pageContext.id;
        }
        return result;
      }));
    }
    getSearchContext() {
      return combineLatest([this.productSearchService.getResults().pipe(startWith({})), this.facetService.facetList$.pipe(startWith({}))]).pipe(map(([searchResult, facetList]) => {
        const facets = facetList?.activeFacets?.map(facet => `${facet.facetCode}:${facet.facetValueCode}`).join(':');
        return {
          facets: facets || undefined,
          searchPhrase: searchResult.freeTextSearch || undefined
        };
      }), distinctUntilChanged((prev, curr) => prev.facets === curr.facets && prev.searchPhrase === curr.searchPhrase));
    }
    static {
      this.ɵfac = function CdsMerchandisingUserContextService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsMerchandisingUserContextService)(i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(i1.ProductSearchService), i0.ɵɵinject(ProfileTagEventService), i0.ɵɵinject(ProfileTagLifecycleService), i0.ɵɵinject(i1$1.FacetService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsMerchandisingUserContextService,
        factory: CdsMerchandisingUserContextService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CdsMerchandisingUserContextService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CdsMerchandisingSiteContextService = /*#__PURE__*/(() => {
  class CdsMerchandisingSiteContextService {
    constructor(baseSiteService, languageService) {
      this.baseSiteService = baseSiteService;
      this.languageService = languageService;
    }
    getSiteContext() {
      return combineLatest([this.baseSiteService.getActive(), this.languageService.getActive()]).pipe(map(([site, language]) => {
        const siteContext = {
          site,
          language
        };
        return siteContext;
      }));
    }
    static {
      this.ɵfac = function CdsMerchandisingSiteContextService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsMerchandisingSiteContextService)(i0.ɵɵinject(i1.BaseSiteService), i0.ɵɵinject(i1.LanguageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsMerchandisingSiteContextService,
        factory: CdsMerchandisingSiteContextService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CdsMerchandisingSiteContextService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CdsMerchandisingProductService = /*#__PURE__*/(() => {
  class CdsMerchandisingProductService {
    constructor(strategyConnector, merchandisingUserContextService, merchandisingSiteContextService) {
      this.strategyConnector = strategyConnector;
      this.merchandisingUserContextService = merchandisingUserContextService;
      this.merchandisingSiteContextService = merchandisingSiteContextService;
    }
    loadProductsForStrategy(strategyId, numberToDisplay) {
      return combineLatest([this.merchandisingSiteContextService.getSiteContext(), this.merchandisingUserContextService.getUserContext()]).pipe(debounceTime(0), map(([siteContext, userContext]) => {
        return {
          queryParams: {
            ...siteContext,
            products: userContext.products,
            category: userContext.category,
            facets: userContext.facets,
            searchPhrase: userContext.searchPhrase,
            pageSize: numberToDisplay
          },
          headers: {
            consentReference: userContext.consentReference
          }
        };
      }), mergeMap(request => this.strategyConnector.loadProductsForStrategy(strategyId, request).pipe(map(products => ({
        request,
        products
      })))));
    }
    static {
      this.ɵfac = function CdsMerchandisingProductService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsMerchandisingProductService)(i0.ɵɵinject(MerchandisingStrategyConnector), i0.ɵɵinject(CdsMerchandisingUserContextService), i0.ɵɵinject(CdsMerchandisingSiteContextService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdsMerchandisingProductService,
        factory: CdsMerchandisingProductService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CdsMerchandisingProductService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const DEFAULT_CAROUSEL_VIEWPORT_THRESHOLD = 80;
let MerchandisingCarouselComponentService = /*#__PURE__*/(() => {
  class MerchandisingCarouselComponentService {
    constructor(cdsMerchandisingProductService, productService, profileTagEventService, cdsConfig) {
      this.cdsMerchandisingProductService = cdsMerchandisingProductService;
      this.productService = productService;
      this.profileTagEventService = profileTagEventService;
      this.cdsConfig = cdsConfig;
    }
    getMerchandisingCaourselViewportThreshold(cmsComponent) {
      const viewportPercentage = cmsComponent.viewportPercentage ?? this.cdsConfig?.cds?.merchandising?.defaultCarouselViewportThreshold ?? DEFAULT_CAROUSEL_VIEWPORT_THRESHOLD;
      return viewportPercentage / 100;
    }
    getMerchandisingCarouselModel(cmsComponent) {
      return this.cdsMerchandisingProductService.loadProductsForStrategy(cmsComponent.strategy, cmsComponent.numberToDisplay).pipe(map(strategy => {
        const metadata = this.getCarouselMetadata(strategy.products, cmsComponent);
        const items$ = this.mapStrategyProductsToCarouselItems(strategy.products);
        const productIds = this.mapStrategyProductsToProductIds(strategy.products);
        const id = this.getMerchandisingCarouselModelId(cmsComponent, strategy.request);
        return {
          id,
          items$,
          productIds,
          metadata,
          title: cmsComponent.title,
          backgroundColor: cmsComponent.backgroundColour,
          textColor: cmsComponent.textColour
        };
      }));
    }
    sendCarouselViewEvent(lastSendModelId, merchandisingCarouselModel$) {
      return merchandisingCarouselModel$.pipe(filter(model => model.id !== lastSendModelId), tap(merchandisingCarouselModel => {
        const carouselEvent = this.getCarouselEventFromCarouselModel(merchandisingCarouselModel);
        this.profileTagEventService.notifyProfileTagOfEventOccurrence(new MerchandisingCarouselViewedEvent(carouselEvent, merchandisingCarouselModel.productIds));
      }));
    }
    sendCarouselItemClickedEvent(merchandisingCarouselModel, clickedProduct) {
      const carouselEvent = this.getCarouselEventFromCarouselModel(merchandisingCarouselModel);
      carouselEvent.metadata = {
        ...carouselEvent.metadata,
        ...clickedProduct.metadata
      };
      this.profileTagEventService.notifyProfileTagOfEventOccurrence(new MerchandisingCarouselClickedEvent(carouselEvent, clickedProduct.metadata.slot, clickedProduct.code, clickedProduct.images?.PRIMARY['product']?.url));
    }
    getCarouselMetadata(strategyProducts, componentData) {
      const metadata = strategyProducts.metadata ?? {};
      if (strategyProducts.products && strategyProducts.products.length) {
        metadata.slots = strategyProducts.products.length;
      }
      metadata.title = componentData.title;
      metadata.name = componentData.name;
      metadata.strategyid = componentData.strategy;
      metadata.id = componentData.uid;
      return metadata;
    }
    mapStrategyProductsToCarouselItems(strategyProducts) {
      return strategyProducts && strategyProducts.products ? strategyProducts.products.map((strategyProduct, index) => this.productService.get(strategyProduct.id, ["details" /* ProductScope.DETAILS */, "price" /* ProductScope.PRICE */]).pipe(map(product => ({
        ...product,
        metadata: this.getCarouselItemMetadata(strategyProduct, index + 1)
      })))) : [EMPTY];
    }
    mapStrategyProductsToProductIds(strategyProducts) {
      return strategyProducts && strategyProducts.products ? strategyProducts.products.map(strategyProduct => strategyProduct.id) : [];
    }
    getMerchandisingCarouselModelId(cmsComponent, request) {
      return cmsComponent.uid + '_' + cmsComponent.strategy + '_' + JSON.stringify(request.queryParams);
    }
    getCarouselItemMetadata(strategyProduct, index) {
      const metadata = strategyProduct.metadata ?? {};
      metadata.slot = index;
      metadata.id = strategyProduct.id;
      return metadata;
    }
    getCarouselEventFromCarouselModel(carouselModel) {
      return {
        carouselId: carouselModel.metadata.id,
        carouselName: carouselModel.metadata.name,
        strategyId: carouselModel.metadata.strategyid,
        metadata: carouselModel.metadata
      };
    }
    static {
      this.ɵfac = function MerchandisingCarouselComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MerchandisingCarouselComponentService)(i0.ɵɵinject(CdsMerchandisingProductService), i0.ɵɵinject(i1.ProductService), i0.ɵɵinject(ProfileTagEventService), i0.ɵɵinject(CdsConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MerchandisingCarouselComponentService,
        factory: MerchandisingCarouselComponentService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MerchandisingCarouselComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MerchandisingCarouselComponent = /*#__PURE__*/(() => {
  class MerchandisingCarouselComponent {
    constructor(componentData, merchandisingCarouselComponentService, routingService, intersectionService, el) {
      this.componentData = componentData;
      this.merchandisingCarouselComponentService = merchandisingCarouselComponentService;
      this.routingService = routingService;
      this.intersectionService = intersectionService;
      this.el = el;
      /**
       * returns an Observable string for the title.
       */
      this.title$ = this.componentData.data$.pipe(filter(data => Boolean(data)), map(data => data.title));
      this.fetchProducts$ = this.componentData.data$.pipe(filter(data => Boolean(data)), distinctUntilKeyChanged('strategy'), switchMap$1(data => this.merchandisingCarouselComponentService.getMerchandisingCarouselModel(data)), tap(data => {
        if (typeof data.backgroundColor === 'string') {
          this.el.nativeElement.style.setProperty('--cx-color-background', data.backgroundColor);
        }
        if (typeof data.textColor === 'string') {
          this.el.nativeElement.style.setProperty('--cx-color-text', data.textColor);
        }
      }), shareReplay({
        bufferSize: 1,
        refCount: true
      }));
      this.intersection$ = this.fetchProducts$.pipe(take$1(1), switchMap$1(() => this.routingService.getPageContext().pipe(switchMap$1(() => this.componentData.data$), map(data => this.merchandisingCarouselComponentService.getMerchandisingCaourselViewportThreshold(data)), switchMap$1(threshold => this.intersectionService.isIntersected(this.el.nativeElement, {
        threshold
      }).pipe(filter(carouselIsVisible => carouselIsVisible), switchMap$1(_ => {
        return this.merchandisingCarouselComponentService.sendCarouselViewEvent(this.lastEventModelId, this.fetchProducts$).pipe(tap(model => {
          this.lastEventModelId = model.id;
        }), switchMap$1(() => EMPTY));
      }))))));
      this.merchandisingCarouselModel$ = using(() => this.intersection$.subscribe(), () => this.fetchProducts$);
      this.lastEventModelId = '';
    }
    onMerchandisingCarouselItemClick(merchandisingCarouselModel, clickedProduct) {
      this.merchandisingCarouselComponentService.sendCarouselItemClickedEvent(merchandisingCarouselModel, clickedProduct);
    }
    static {
      this.ɵfac = function MerchandisingCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MerchandisingCarouselComponent)(i0.ɵɵdirectiveInject(i1$1.CmsComponentData), i0.ɵɵdirectiveInject(MerchandisingCarouselComponentService), i0.ɵɵdirectiveInject(i1.RoutingService), i0.ɵɵdirectiveInject(i1$1.IntersectionService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MerchandisingCarouselComponent,
        selectors: [["cx-merchandising-carousel"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [["carouselItem", ""], ["outOfStock", ""], [4, "ngIf"], [1, "data-cx-merchandising-carousel", 3, "cxAttributes", "cxAttributesNamePrefix"], ["itemWidth", "285px", 3, "items", "title", "template"], [1, "data-cx-merchandising-product", 3, "cxAttributes", "cxAttributesNamePrefix"], ["tabindex", "0", 3, "click", "routerLink"], ["format", "product", 3, "container", 4, "ngIf"], [1, "price"], ["class", "price", 4, "ngIf", "ngIfElse"], ["format", "product", 3, "container"]],
        template: function MerchandisingCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MerchandisingCarouselComponent_ng_container_0_Template, 6, 7, "ng-container", 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.merchandisingCarouselModel$));
          }
        },
        dependencies: [i2.NgIf, AttributesDirective, i1$1.CarouselComponent, i1$1.MediaComponent, i6.RouterLink, i2.AsyncPipe, i1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MerchandisingCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MerchandisingCarouselCmsModule = /*#__PURE__*/(() => {
  class MerchandisingCarouselCmsModule {
    static {
      this.ɵfac = function MerchandisingCarouselCmsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MerchandisingCarouselCmsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MerchandisingCarouselCmsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            MerchandisingCarouselComponent: {
              component: MerchandisingCarouselComponent
            }
          }
        })],
        imports: [CommonModule, AttributesModule, CarouselModule, MediaModule, RouterModule, UrlModule]
      });
    }
  }
  return MerchandisingCarouselCmsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MerchandisingModule = /*#__PURE__*/(() => {
  class MerchandisingModule {
    static {
      this.ɵfac = function MerchandisingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MerchandisingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MerchandisingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: MerchandisingStrategyAdapter,
          useClass: CdsMerchandisingStrategyAdapter
        }],
        imports: [MerchandisingCarouselCmsModule]
      });
    }
  }
  return MerchandisingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RecentSearchesService = /*#__PURE__*/(() => {
  class RecentSearchesService {
    constructor(winRef) {
      this.winRef = winRef;
      this.recentSearchesSource = new ReplaySubject();
      this.recentSearches$ = this.recentSearchesSource.asObservable();
      if (this.winRef.isBrowser()) {
        this.addRecentSearchesListener();
      }
    }
    checkAvailability() {
      return interval(250).pipe(concatMap(_ => of(this.winRef.nativeWindow?.Y_TRACKING)), map(result => !!result?.recentSearches), take$1(100), takeWhile(val => !val, true), last());
    }
    addRecentSearchesListener() {
      this.checkAvailability().pipe(take$1(1)).subscribe(result => {
        if (result) {
          const recentPhrases = this.winRef.nativeWindow?.Y_TRACKING?.recentSearches?.getPhrases();
          if (recentPhrases) {
            this.recentSearchesSource.next(recentPhrases);
            this.winRef.nativeWindow?.Y_TRACKING?.recentSearches?.addListener(recentSearches => {
              this.recentSearchesSource.next(recentSearches);
            });
          }
        }
      });
    }
    static {
      this.ɵfac = function RecentSearchesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RecentSearchesService)(i0.ɵɵinject(i1.WindowRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RecentSearchesService,
        factory: RecentSearchesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RecentSearchesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const MAX_RECENT_SEARCHES = 5;
let RecentSearchesComponent = /*#__PURE__*/(() => {
  class RecentSearchesComponent {
    constructor(outletContext) {
      this.outletContext = outletContext;
      this.recentSearchesService = inject(RecentSearchesService);
      this.searchBoxComponentService = inject(SearchBoxComponentService);
    }
    ngOnInit() {
      this.result$ = combineLatest([this.outletContext?.context$, this.recentSearchesService.recentSearches$]).pipe(map(([context, recentSearches]) => recentSearches.filter(phrase => phrase.toLowerCase().indexOf(context.search.toLowerCase()) >= 0).slice(0, context.maxRecentSearches ?? MAX_RECENT_SEARCHES)), tap(results => {
        this.searchBoxComponentService.setRecentSearches(!!results.length);
      }));
      this.outletContext$ = this.outletContext.context$;
    }
    preventDefault(ev) {
      ev.preventDefault();
    }
    updateChosenWord(chosenWord) {
      this.searchBoxComponentService.changeSelectedWord(chosenWord);
    }
    shareEvent(event) {
      if (!event) {
        throw new Error('Missing Event');
      }
      this.searchBoxComponentService.shareEvent(event);
    }
    static {
      this.ɵfac = function RecentSearchesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RecentSearchesComponent)(i0.ɵɵdirectiveInject(i1$1.OutletContextData, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RecentSearchesComponent,
        selectors: [["cx-recent-searches"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "recent-searches"], ["tabindex", "0", "role", "listbox", 3, "ariaLabel"], [4, "ngFor", "ngForOf"], ["role", "option", 3, "mousedown", "keydown.arrowup", "keydown.arrowdown", "keydown.arrowleft", "keydown.arrowright", "keydown.enter", "keydown.escape", "blur", "click", "innerHTML", "routerLink"]],
        template: function RecentSearchesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, RecentSearchesComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.result$));
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i6.RouterLink, i2.AsyncPipe, i1.TranslatePipe, i1$1.HighlightPipe, i1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return RecentSearchesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RecentSearchesModule = /*#__PURE__*/(() => {
  class RecentSearchesModule {
    static {
      this.ɵfac = function RecentSearchesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RecentSearchesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RecentSearchesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: SearchBoxOutlets.RECENT_SEARCHES,
          component: RecentSearchesComponent,
          position: OutletPosition.AFTER
        })],
        imports: [CommonModule, I18nModule, SearchBoxModule, UrlModule, RouterModule]
      });
    }
  }
  return RecentSearchesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const AVAILABILITY_CHECK_INTERVAL = 250;
const MAX_AVAILABILITY_CHECKS = 100;
const POLL_INTERVAL = 15 * 60000; // 15 minutes
const TRENDING_SEARCHES_ENDPOINT_KEY = 'searchIntelligence';
let TrendingSearchesService = /*#__PURE__*/(() => {
  class TrendingSearchesService {
    constructor() {
      this.baseSiteService = inject(BaseSiteService);
      this.cdsConfig = inject(CdsConfig);
      this.cdsEndpointsService = inject(CdsEndpointsService);
      this.httpClient = inject(HttpClient);
      this.winRef = inject(WindowRef);
      this.destroy$ = new Subject();
      this.trendingSearches$ = this.initTrendingSearches().pipe(shareReplay$1(1));
    }
    checkAvailability() {
      return timer(0, AVAILABILITY_CHECK_INTERVAL).pipe(map$1(() => this.winRef.nativeWindow?.Y_TRACKING?.config?.cdsSiteId), takeWhile$1(cdsSiteId => !cdsSiteId, true), take(MAX_AVAILABILITY_CHECKS), filter$1(cdsSiteId => !!cdsSiteId));
    }
    constructTrendingSearchUrl(cdsSiteId) {
      const originalEndpointUrl = this.cdsEndpointsService.getUrl(TRENDING_SEARCHES_ENDPOINT_KEY).replaceAll('${cdsSiteId}', cdsSiteId);
      const expectedPrefix = `https://${this.cdsConfig.cds.tenant}-${cdsSiteId}.`;
      if (!originalEndpointUrl.startsWith(expectedPrefix)) {
        return originalEndpointUrl.replace(/https:\/\//g, expectedPrefix);
      }
      return originalEndpointUrl;
    }
    fetchTrendingSearches(url) {
      return this.httpClient.get(url).pipe(map$1(data => data?.searchPhrases), catchError(() => {
        return EMPTY;
      }));
    }
    initTrendingSearches() {
      return this.checkAvailability().pipe(switchMap(cdsSiteId => {
        const url = this.constructTrendingSearchUrl(cdsSiteId);
        return timer(0, POLL_INTERVAL).pipe(switchMap(() => this.fetchTrendingSearches(url)), takeUntil(this.destroy$));
      }));
    }
    getTrendingSearches() {
      return this.trendingSearches$;
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function TrendingSearchesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrendingSearchesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TrendingSearchesService,
        factory: TrendingSearchesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TrendingSearchesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const MAX_TRENDING_SEARCHES = 5;
let TrendingSearchesComponent = /*#__PURE__*/(() => {
  class TrendingSearchesComponent {
    constructor() {
      this.searchBoxComponentService = inject(SearchBoxComponentService);
      this.trendingSearchesService = inject(TrendingSearchesService);
      this.outletContext = inject(OutletContextData, {
        optional: true
      });
    }
    ngOnInit() {
      this.searchPhrases$ = this.getSearchPhrases().pipe(tap(searchPhrases => {
        this.searchBoxComponentService.setTrendingSearches(!!searchPhrases.length);
      }));
    }
    getSearchPhrases() {
      return this.contextObservable.pipe(switchMap$1(context => {
        const maxSearches = context?.maxTrendingSearches ?? MAX_TRENDING_SEARCHES;
        return this.trendingSearchesService.getTrendingSearches().pipe(map(data => data ? data.slice(0, maxSearches) : []));
      }));
    }
    get contextObservable() {
      return this.outletContext?.context$ ?? EMPTY;
    }
    shareEvent(event) {
      if (!event) {
        throw new Error('Missing Event');
      }
      this.searchBoxComponentService.shareEvent(event);
    }
    static {
      this.ɵfac = function TrendingSearchesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrendingSearchesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TrendingSearchesComponent,
        selectors: [["cx-trending-searches"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "trending-searches"], ["tabindex", "0", 3, "ariaLabel"], [4, "ngFor", "ngForOf"], ["role", "option", 3, "mousedown", "keydown.arrowup", "keydown.arrowdown", "keydown.arrowleft", "keydown.arrowright", "keydown.enter", "keydown.escape", "routerLink"]],
        template: function TrendingSearchesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TrendingSearchesComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.searchPhrases$));
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i6.RouterLink, i2.AsyncPipe, i1.TranslatePipe, i1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TrendingSearchesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let TrendingSearchesModule = /*#__PURE__*/(() => {
  class TrendingSearchesModule {
    static {
      this.ɵfac = function TrendingSearchesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrendingSearchesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TrendingSearchesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: SearchBoxOutlets.TRENDING_SEARCHES,
          component: TrendingSearchesComponent,
          position: OutletPosition.AFTER
        })],
        imports: [CommonModule, I18nModule, SearchBoxModule, UrlModule, RouterModule]
      });
    }
  }
  return TrendingSearchesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CdsModule = /*#__PURE__*/(() => {
  class CdsModule {
    static forRoot(config) {
      return {
        ngModule: CdsModule,
        providers: [provideDefaultConfigFactory(defaultCdsConfigFactory), provideDefaultConfig(config), provideConfigValidator(cdsConfigValidator), ProfileTagPushEventsService]
      };
    }
    static {
      this.ɵfac = function CdsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CdsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [ProfileTagModule, TrackingModule, MerchandisingModule, RecentSearchesModule, TrendingSearchesModule]
      });
    }
  }
  return CdsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** @deprecated  Use @spartacus/cds/assets instead */
const cdsTranslations = cdsTranslations$1;
/** @deprecated  Use @spartacus/cds/assets instead */
const cdsTranslationChunksConfig = cdsTranslationChunksConfig$1;

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface for CDS
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddedToCartPushEvent, AttributesDirective, AttributesModule, BrandPageVisitedEvent, CartSnapshotPushEvent, CartViewPushEvent, CategoryViewPushEvent, CdsBackendConnector, CdsBackendNotificationAdapter, CdsConfig, CdsMerchandisingProductService, CdsMerchandisingSiteContextService, CdsMerchandisingStrategyAdapter, CdsMerchandisingUserContextService, CdsModule, ConsentChangedPushEvent, ConsentReferenceInterceptor, DebugInterceptor, HomePageViewPushEvent, InternalProfileTagEventNames, KeywordSearchPushEvent, MerchandisingCarouselClickedEvent, MerchandisingCarouselCmsModule, MerchandisingCarouselComponent, MerchandisingCarouselComponentService, MerchandisingCarouselViewedEvent, MerchandisingModule, MerchandisingStrategyAdapter, MerchandisingStrategyConnector, ModifiedCartPushEvent, NavigatedPushEvent, OccBackendNotification, OrderConfirmationPushEvent, ProductViewPushEvent, ProfileTagCmsModule, ProfileTagComponent, ProfileTagEventService, ProfileTagInjectorService, ProfileTagLifecycleService, ProfileTagModule, ProfileTagPushEventsService, RemovedFromCartPushEvent, TrackingModule, TrackingService, cdsConfigValidator, cdsTranslationChunksConfig, cdsTranslations, defaultCdsConfigFactory };
